const basico9 = {
    titulo: `JavaScript: estructura repetitiva while`,
    problemas: [
      {
        codigo: 1,
        descripcion: `Una estructura repetitiva permite ejecutar una instrucción o un conjunto de instrucciones varias veces.
Una ejecución repetitiva de sentencias se caracteriza por:
<pre>
- La o las sentencias que se repiten.
- La condición antes de cada repetición, que motivará que se repitan o no las sentencias.
</pre>        
La sintaxis para mostrar los números del 1 al 10 con un while es:
<pre>
let contador = 1
while (contador <= 10) {
  console.log(contador)
  contador=contador+1
}
</pre>
<p>Mientras la condición se verifica verdadera, se ejecutan las sentencias, en nuestro caso se muestra el contenido de la variable contador y pasa luego a incrementarse en 1 dicha variable. Cuando la variable contador toma el valor 11, la condición se verifica falsa y por lo tanto finaliza la estructura repetitiva.</p>`,
        programa: `let contador = 1
let acumulador = 0
while (contador <= 5) {
  acumulador = acumulador + contador
  contador++
}
console.log(acumulador)`,
        solucion: "15",
      }, {
        codigo: 2,
        descripcion: `Sumar todos los valores pares entre 2 y 10.`,
        programa: `let suma = 0
let par = 2
while (par <= 10) {
  suma = suma + par
  par = par + 2
}
console.log(suma)`,
        solucion: "30",
      }
    ]
  }
  
  export default basico9;